<template>
  <el-dialog :title="title"
             :visible.sync="dialogFormVisible"
             custom-class="list-dialog"
             center
             :close-on-click-modal="false" :show-close="true"
             :append-to-body="true"
             :modal="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="12">
          <el-select class="Select" v-model="cangkucode" placeholder="请选择仓库" style="width:130px" @change="bindGrid">
            <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                       :label="item.cangkuname"
                       :value="item.cangkucode">
            </el-option>
          </el-select>
          <!--<CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindTree" :isShowCheckBox="false"-->
                      <!--:treeHeight="400" :treeWidth="400" :searchText="seedname" :canDelete="false"-->
                      <!--style="width:200px;display: inline-block;" @check="checktree"></CommonTree>-->
          <el-date-picker
            v-model="plmonthrange"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>
        </el-col>
        <el-button type="primary"  @click="jisuanstock">计算</el-button>
        <el-button  @click="exportExceltable">导出</el-button>
      </el-col>
    </div>
    <el-col :span="24">
      <el-col :span="21">

      </el-col>
    </el-col>
  </el-dialog>
</template>

<script>
  import {  goodssalenum} from '@/api/set/jxcresultstore';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getPrice} from '@/api/set/goodsprice';
  import {saveData} from '@/api/set/jxcstorelimit';
  import {getFramelistwithstore} from '@/api/set/jxcresultstore';

  export default {
    name: "zhinengstock",
    data() {
      return {
        costpricebook: {},
        title: '滞销镜架',
        dialogFormVisible: false,
        monthvalue:[],
        plmonthrange:[],
        initContent: [],
        initContentLeft: [],
        initContentRight: [],
        erweitable: [],//二维表
        erweitableleft: [],
        erweitableright: [],
        categorycode: '',//商品编码
        cangkucode: '',//仓库编码
        filltemplate: '',//
        jxcstoreData: [],//仓库
        tableData: [],
        tableData2: [],
        tableStoreDetail: [],
        showzuoyoutable: false,
        showerweitable: false,
        erpserials: "",//销售单明细
        monthflag: [],//月份
        number: 0,
        form: {  //表单数据
          seedcode: "",
          minstorebook: "",
          maxstorebook: "",
          cangkucode: "",
          enabled: 1,
          filltemplate: ""
        },
      }
    },
    methods: {
      totalnumber(num) {
        this.number = num
      },
      //计算库存
      jisuanstock() {
        if (this.plmonthrange.length == 0) {
          this.$message.error("请先选择月份");
          return
        }
        var bgdate = new Date(this.plmonthrange[0]);
        var eddate = new Date(this.plmonthrange[1]);
        var edmonth = eddate.getMonth() + 1;
        var edyear = null;
        if (edmonth == 12) {
          edyear = bgdate.getFullYear() + 1;
          edmonth = 1;
        } else {
          edyear = bgdate.getFullYear();
          edmonth = edmonth + 1;
        }
        goodssalenum({
          begindate: bgdate.getFullYear() + "-" + (bgdate.getMonth() + 1) + "-1",
          enddate: edyear + '-' + edmonth + '-1',
          categorycode: this.categorycode,
          cangkucode: this.cangkucode
        }).then(response => {
          console.log(response.data.obj)
          //返回光度的销售量
          var lowContent = [];
          for (let i in this.initContent) {
            var kuRow = this.initContent[i];
            kuRow.P= kuRow.openbalnum + kuRow.debitnum - kuRow.creditnum ;;
            if (!kuRow.P || !(parseInt(kuRow.P) > 0)) continue;

            var hasValue = false;
            for (let j in response.data.obj) {
              var row = response.data.obj[j];
              var pg = JSON.parse(row.packagesize);
              if (kuRow.seedcode == row.seedcode && parseFloat(pg.M) == parseFloat(kuRow.M) && parseFloat(pg.C) == parseFloat(kuRow.C)) {
                hasValue = true;
                break;
              }
            }
            if (!hasValue) {//没有销量的库存
              lowContent.push(kuRow);
            }
          }
          console.log(this.initContent)
          console.log(lowContent)
          this.tableData=lowContent;
        })
      },
      exportExceltable() {
        this.$refs.referweibiao.getExcel( this.seedname);
      },
      show(obj) {
        this.tableData = [];
        this.initContent = [];
        this.filltemplate = obj.filltemplate
        this.categorycode = obj.categorycode
        this.jxcstoreData = obj.jxcstoreData
        this.cangkucode='no';
        if (obj.jxcstoreData.length > 0) {
          this.cangkucode = obj.jxcstoreData[0].cangkucode
          this.dialogFormVisible = true;
        }
        this.bindGrid();
      },
      bindGrid() {//绑定列表
        var date = new Date();

        this.initContent = [];
        getFramelistwithstore({
          searchdata: '',//产品名称（保留 暂不考虑）
          categorycode: this.categorycode,//产品分类（单选）
          cangkucode: this.cangkucode,//选择的仓库（多选）
          seedcode: '',
          minyear: date.getFullYear(),
          minmonth: date.getMonth() + 1,
          maxyear: date.getFullYear(),
          maxmonth:date.getMonth() + 1,
          nostock: 1,
        }).then(response => {
          this.initContent = response.data.obj
        }).catch((error) => {
          console.log(error)
        });
      },
      bindTree() {//绑定树控件
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1})
        })
      },
    },
    mounted() {

    },
    components: {
      TwoDimensionalTable
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/zhinengstockframe.vue